import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import { BizAppConfig } from 'config/application.manifest';
import {
  PERMISSION_ACTION_CODES,
  PERMISSION_RESOURCE_CODES,
} from '@/permissions/definitions';

const buildUnrestrictedAccessMap = (
  authorizedResourceAccess: AuthorizedResourceAccessMap = {},
): AuthorizedResourceAccessMap => {
  const unrestrictedAccessMap: AuthorizedResourceAccessMap = {
    ...authorizedResourceAccess,
  };

  Object.values(PERMISSION_RESOURCE_CODES).forEach((resourceCode) => {
    unrestrictedAccessMap[resourceCode] = true;
  });

  Object.entries(PERMISSION_ACTION_CODES).forEach(
    ([resourceKey, resourceActions]) => {
      const resourceCode =
        PERMISSION_RESOURCE_CODES[
          resourceKey as keyof typeof PERMISSION_RESOURCE_CODES
        ];

      Object.values(resourceActions).forEach((actionCode) => {
        unrestrictedAccessMap[`${resourceCode}:${actionCode}`] = true;
      });
    },
  );

  return unrestrictedAccessMap;
};

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
      }
    | undefined,
) {
  if (!BizAppConfig.enableResourceGuard || initialState?.currentTenantIsAdmin) {
    return buildUnrestrictedAccessMap(initialState?.authorizedResourceAccess);
  }
  return initialState?.authorizedResourceAccess ?? {};
}
